export default "__VITE_ASSET__9209737b__"